import { RowCrudStatus } from "../../common/types";
import {
  DashboardLayoutTemplate,
  DashboardLayoutTemplateCreateMutationVariables,
  DashboardLayoutTemplateUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { blankToNull } from "../../../common/blankToNull";
import { safeJsonParse } from "../../../common/utils";

export type DashboardLayoutTemplateValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  forRole: string;
  widgets: string;
  isDefault: boolean;
  enabled: boolean;
  isForAllTenants: boolean;
};

export type DashboardLayoutTemplateErrorsType = {
  name?: { message: string; fieldLabel: string };
  forRole?: { message: string; fieldLabel: string };
  widgets?: { message: string; fieldLabel: string };
  isDefault?: { message: string; fieldLabel: string };
  enabled?: { message: string; fieldLabel: string };
  isForAllTenants?: { message: string; fieldLabel: string };
};

export function DashboardLayoutTemplateValuesInit(): DashboardLayoutTemplateValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    forRole: "",
    widgets: "{}",
    isDefault: false,
    enabled: false,
    isForAllTenants: false,
  };
}

export type DashboardLayoutTemplateType =
  | DashboardLayoutTemplate
  | DashboardLayoutTemplateValuesType;

export function dashboardLayoutTemplateDisplayId(
  source: Partial<DashboardLayoutTemplate>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getDashboardLayoutTemplateValues(
  source: DashboardLayoutTemplateType,
  _langStore: LangStore,
  _duplicated: boolean = false
): DashboardLayoutTemplateValuesType {
  const entityValues = DashboardLayoutTemplateValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : dashboardLayoutTemplateDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.forRole = source.forRole || "";
  entityValues.widgets = source.widgets;
  entityValues.isDefault = source.isDefault || false;
  entityValues.enabled = source.enabled || false;
  entityValues.isForAllTenants = source.isForAllTenants || false;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getDashboardLayoutTemplateUpdateVariables(
  values: DashboardLayoutTemplateValuesType
): DashboardLayoutTemplateUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
    forRole: blankToNull(values.forRole),
    widgets: safeJsonParse(values.widgets, "widgets"),
    isDefault: values.isDefault,
    enabled: values.enabled,
    isForAllTenants: values.isForAllTenants,
  };
}

export function getDashboardLayoutTemplateCreateVariables(
  values: DashboardLayoutTemplateValuesType
): DashboardLayoutTemplateCreateMutationVariables {
  return {
    name: values.name,
    forRole: blankToNull(values.forRole),
    widgets: safeJsonParse(values.widgets, "widgets"),
    isDefault: values.isDefault,
    enabled: values.enabled,
    isForAllTenants: values.isForAllTenants,
  };
}
